import LoginForm from "../../components/form/LoginForm";
import { Link, useNavigate } from "react-router-dom";
import styles from "./login.module.css";
import { StorageGetItem } from "../../../admin/components/StorageComp";
import Loader from "../../../admin/components/Loader";
import { useState } from "react";
import { Home } from "react-feather";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit() {
    const authData = StorageGetItem("bookAuthData");
    let loginData = JSON.parse(authData);

    if (loginData?.user_type === 5) {
      setTimeout(() => {
        navigate("/customer/my-bookings");
      }, 100);
    } else if (loginData?.user_type === 3) {
      setTimeout(() => {
        navigate("/driver/today-request-list");
      }, 100);
    } else {
      setTimeout(() => {
        navigate("/dashboard");
      }, 100);
    }
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.LoginFormSec}`}>
        <div className={`${styles.LohinForm}`}>
          <Link to={"/"} className={`${styles.BackHomeBU}`}><Home />Back to home</Link>
          <h2 className={`${styles.BookingFormTitle} ${styles.Heading}`}>Login</h2>
          <p className={`${styles.LoginformSmTitle}`}>Login your account</p>
          <LoginForm onSubmit={onSubmit.bind(this)} isFP={true} setLoading={setLoading.bind(this)} />
        </div>
      </div>

      <div className={`${styles.LoginBGSec}`}>
        <img src="/images/loginBG1.jpg" alt="" />
      </div>
    </div>
  </>);
}

export default Login;